import React, { useState, useEffect } from "react";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../provider/AuthProvider";
import UseTitle from "../../components/useTitle";
import "./CampaignNew.scss";

const CampaignNew = () => {
  // Définition du titre de la page
  UseTitle("Création d'une campagne");

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [charactersList, setCharactersList] = useState([]);
  const [charactersSelected, setCharactersSelected] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [messageError, setMessageError] = useState();

  const [redirectTo, setRedirectTo] = useState();

  // Vérification de la campagne
  const checkCampaign = () => {
    setMessageError();
    if (!name) {
      setMessageError("Nom manquant");
      return false;
    }
    return true;
  };

  // Création de la campagne
  const handleCreate = () => {
    if (!checkCampaign()) {
      return;
    }

    setIsLoading(true);

    const campaign = {
      name: name,
      description: description,
      characters: charactersSelected,
    };
    api
      .post("/campaign/", campaign)
      .then((response) => {
        setRedirectTo(`/campaign/${response.data.id}`);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // Sélection de tous les personnages
  const handleSelectAllCharacters = () => {
    if (charactersSelected.length === charactersList.length) {
      setCharactersSelected([]);
    } else {
      setCharactersSelected(charactersList.map((character) => character.id));
    }
  };

  // Sélection d'un personnage
  const handleSelectCharacter = (characterId) => {
    if (charactersSelected.includes(characterId)) {
      setCharactersSelected(
        charactersSelected.filter((id) => id !== characterId)
      );
    } else {
      setCharactersSelected([...charactersSelected, characterId]);
    }
  };

  // Récupération de la liste des personnages
  useEffect(() => {
    api
      .get("/character/all/")
      .then((response) => {
        setCharactersList(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  if (redirectTo) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return (
    <div className="campaign-new">
      {isLoading ? (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      ) : (
        <>
          <h1>Nouvelle campagne</h1>

          <section className="campaign-section">
            <h2>Informations générales</h2>
            <div className="campaign-info">
              <label htmlFor="campaign-name">Nom</label>
              <input
                type="text"
                id="campaign-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Nom"
              />
            </div>
            <div className="campaign-info">
              <label htmlFor="description">Description</label>
              <textarea
                name="description"
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Description"
              ></textarea>
            </div>
          </section>

          <section className="campaign-section">
            <h2>
              Personnages associés <small>({charactersSelected.length})</small>
            </h2>
            <div className="select">
              <div className="select-all">
                <input
                  type="checkbox"
                  id="select-all"
                  checked={charactersSelected.length === charactersList.length}
                  onChange={handleSelectAllCharacters}
                />
                <label htmlFor="select-all">Tous les personnages</label>
              </div>
              <div className="characters-list">
                {charactersList.map((character) => (
                  <div className="character-list" key={character.id}>
                    <input
                      type="checkbox"
                      id={`character-${character.id}`}
                      checked={charactersSelected.includes(character.id)}
                      onChange={(e) => handleSelectCharacter(character.id)}
                    />
                    <label htmlFor={`character-${character.id}`}>
                      {character.name}{" "}
                      <small>({character.user_proprietary})</small>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <div className="buttons">
            <button
              className={!name ? "bt disabled" : "bt"}
              type="button"
              onClick={handleCreate}
              disabled={!name}
            >
              Enregistrer
            </button>
          </div>
          {messageError && <p className="error">{messageError}</p>}
        </>
      )}
    </div>
  );
};

export default CampaignNew;
